/**
 * Login 的状态管理
 */
import { GET, URLS, POST, PUT } from "../../utils";

export const types = {
  FETCH_ATTENTION_USER_LIST: "USER/FETCH_ATTENTION_USER_LIST"
};

const state = {
  attention_user: {
    page: 1,
    page_size: 10,
    total_count: 0,
    load_more:false,
    data: []
  }
};

const mutations = {
  set_load_more(state, param) {
    // param: {"value": true, "data_type":"member"}
    if (param.data_type === types.FETCH_ATTENTION_USER_LIST) {
      state.attention_user.load_more = param.value;
    } 
  },
  set_pagenum(state, param) {
    // param: {"value": 3, "data_type":"member"}
    if (param.data_type === types.FETCH_ATTENTION_USER_LIST) {
      state.attention_user.page = param.value;
    } 
  },
  set_list_data(state, param) {
    // param: {"data": [], "data_type":"member"}
    if (param.data_type === types.FETCH_ATTENTION_USER_LIST) {
      if (state.attention_user.page === 1) {
        state.attention_user.data = param.data;
      } else {
        state.attention_user.data = state.attention_user.data.concat(param.data);
      }
      state.attention_user.total_count = param.count;
    }
  }
};

const actions = {
  /**
   * @用户列表请求
   * @param {*} param {"page":1, "name":""}
   */
  [types.FETCH_ATTENTION_USER_LIST](
    { dispatch, commit, state, rootState, rootGetter },
    param
  ) {
    // param: {"page":1}
    let temp_dic = { data_type: types.FETCH_ATTENTION_USER_LIST };
    commit("set_load_more", { ...temp_dic, value: false });
    commit("set_pagenum", { ...temp_dic, value: param.page });

    GET(URLS.list_attention_user(state.attention_user.page, param.name)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit("set_load_more", { ...temp_dic, value: true });
      } else {
        commit("set_load_more", { ...temp_dic, value: false });
      }

      // 跟新数据源
      commit("set_list_data", {
        ...temp_dic,
        data: response.results,
        count: response.count
      });

    });
  }
};
const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
